import { NgModule } from '@angular/core';
import { ClaimService } from '../claims/claim.service';
import { RentalAndTowComponent } from './rental-and-tow/rental-and-tow.component';
import { RentalAndTowCustomerComponent } from './rental-and-tow-customer/rental-and-tow-customer.component';
import { RentalReimbursementInfoComponent } from './rental-and-tow/rental-reimbursement-info/rental-reimbursement-info.component';
import { TowReimbursementInfoComponent } from './rental-and-tow/tow-reimbursement-info/tow-reimbursement-info.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../shared/shared.module';
import { AppRouterModule } from '../app.router.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { ReimbursementClaimSubmittedComponent } from './reimbursement-claim-submitted/reimbursement-claim-submitted';
import { TripReimbursementInfoComponent } from './rental-and-tow/trip-reimbursement-info/trip-reimbursement-info.component';

@NgModule({
    declarations: [
        RentalAndTowComponent,
        RentalAndTowCustomerComponent,
        RentalReimbursementInfoComponent,
        TowReimbursementInfoComponent,
        TripReimbursementInfoComponent,
        ReimbursementClaimSubmittedComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FontAwesomeModule,
        ReactiveFormsModule,
        FormsModule,
        SharedModule,
        AppRouterModule,
        MatCheckboxModule,
        MatCardModule,
        MatIconModule,
        MatListModule,
        NgbModule
    ],
    providers: [
        { provide: 'CLAIM_SERVICE', useValue: ClaimService },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class ReimbursementModule {  }
